"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../mobileConfigRight/index.js"));
var _index2 = _interopRequireDefault(require("../rightBtn/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var getDefaultHomeCardList = function getDefaultHomeCardList() {
  return [{
    type: 'stats',
    layout: 'stats',
    title: '平台数据',
    status: true,
    stats: [{
      label: '商户',
      value: '3000位',
      status: true,
      trend: true,
      icon: 'icon-ic_mall',
      iconImage: ''
    }, {
      label: '活动',
      value: '100场',
      status: true,
      trend: true,
      icon: 'icon-ic_notes',
      iconImage: ''
    }, {
      label: '场地',
      value: '50个',
      status: true,
      trend: true,
      icon: 'icon-ic_location1',
      iconImage: ''
    }, {
      label: '集市',
      value: '12家',
      status: true,
      trend: true,
      icon: 'icon-zhuanti',
      iconImage: ''
    }, {
      label: '浏览',
      value: '0次',
      status: true,
      trend: true,
      icon: 'icon-liulan',
      iconImage: ''
    }]
  }, {
    type: 'action',
    layout: 'primary',
    title: '摊友地带',
    desc: '覆盖234个街区 | 共230位会员',
    buttonText: '去看看',
    url: '',
    status: true
  }, {
    type: 'action',
    layout: 'secondary',
    title: '联盟大厅',
    desc: '推广活动赚佣金',
    buttonText: '',
    url: '',
    badgeImage: '',
    status: true
  }];
};
var normalizeHomeCardList = function normalizeHomeCardList() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return getDefaultHomeCardList().map(function (item, index) {
    var current = list[index] || {};
    var currentStats = Array.isArray(current.stats) ? current.stats : [];
    return _objectSpread(_objectSpread(_objectSpread({}, item), current), {}, {
      stats: item.type === 'stats' ? item.stats.map(function (metric, metricIndex) {
        return _objectSpread(_objectSpread({}, metric), currentStats[metricIndex] || {});
      }) : []
    });
  });
};
var _default = exports.default = {
  name: 'c_home_comb',
  componentsName: 'home_comb',
  cname: '头部组件',
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  components: _objectSpread(_objectSpread({}, _index.default), {}, {
    rightBtn: _index2.default
  }),
  data: function data() {
    return {
      hotIndex: 1,
      configObj: {},
      rCom: [{
        components: _index.default.c_checked_tab,
        configNme: 'setUp'
      }]
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = this.mergeConfig(value);
    },
    configObj: {
      handler: function handler(nVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.tabConfig.tabVal': {
      handler: function handler(nVal) {
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          var tempArr = [{
            components: _index.default.c_title,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'searConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'searConfig'
          }, {
            components: _index.default.c_upload_img,
            configNme: 'logoConfig'
          }, {
            components: _index.default.c_upload_img,
            configNme: 'logoFixConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'placeWords'
          }, {
            components: _index.default.c_input_item,
            configNme: 'placeWords'
          }, {
            components: _index.default.c_title,
            configNme: 'hotWords'
          }, {
            components: _index.default.c_hot_word,
            configNme: 'hotWords'
          }, {
            components: _index.default.c_input_item,
            configNme: 'titleConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'textColor'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'textColor'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'borderColor'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'textPosition'
          }, {
            components: _index.default.c_slider,
            configNme: 'contentStyle'
          }];
          this.rCom = arr.concat(tempArr);
        } else if (nVal == 1) {
          var _tempArr = [{
            components: _index.default.c_title,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'listConfig'
          }, {
            components: _index.default.c_radio,
            configNme: 'tabShowConfig'
          }, {
            components: _index.default.c_classify,
            configNme: 'listConfig'
          }];
          this.rCom = arr.concat(_tempArr);
        } else if (nVal == 2) {
          var _tempArr2 = [{
            components: _index.default.c_title,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'swiperConfig'
          }, {
            components: _index.default.c_radio,
            configNme: 'bannerShowConfig'
          }, {
            components: _index.default.c_radio,
            configNme: 'swiperStyleConfig'
          }, {
            components: _index.default.c_menu_list,
            configNme: 'swiperConfig'
          }, {
            components: _index.default.c_title,
            configNme: 'docConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'txtStyle'
          }, {
            components: _index.default.c_radio,
            configNme: 'themeStyleConfig'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'docColor'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'docConfig'
          }, {
            components: _index.default.c_slider,
            configNme: 'contentStyleBanner'
          }];
          this.rCom = arr.concat(_tempArr2);
        } else if (nVal == 3) {
          var _tempArr3 = [{
            components: _index.default.c_title,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_txt_tab,
            configNme: 'tabConfig'
          }, {
            components: _index.default.c_radio,
            configNme: 'cardSectionShowConfig'
          }, {
            components: _index.default.c_home_comb_cards,
            configNme: 'cardConfig'
          }];
          this.rCom = arr.concat(_tempArr3);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = _this.mergeConfig(value);
    });
  },
  methods: {
    mergeConfig: function mergeConfig(data) {
      var next = JSON.parse(JSON.stringify(data || {}));
      if (!next.tabConfig) next.tabConfig = {
        tabVal: 0,
        list: []
      };
      if (!Array.isArray(next.tabConfig.list) || next.tabConfig.list.length < 4) {
        next.tabConfig.list = [{
          val: '搜索框',
          icon: 'icon-zuhe-sousuokuang',
          count: 1
        }, {
          val: '选项卡',
          icon: 'icon-zuhe-fenlei',
          count: 2
        }, {
          val: '轮播图',
          icon: 'icon-zuhe-lunbotu',
          count: 3
        }, {
          val: '统计数据板块',
          icon: 'icon-zonghe',
          count: 4
        }];
      }
      if (next.tabConfig.list[3]) {
        next.tabConfig.list[3] = _objectSpread(_objectSpread({}, next.tabConfig.list[3]), {}, {
          val: '统计数据板块',
          icon: 'icon-zonghe',
          count: 4
        });
      }
      if (!next.bannerShowConfig) {
        next.bannerShowConfig = {
          title: '轮播图',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '显示'
          }, {
            val: '隐藏'
          }]
        };
      }
      if (!next.cardSectionShowConfig) {
        next.cardSectionShowConfig = {
          title: '统计数据板块',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '显示'
          }, {
            val: '隐藏'
          }]
        };
      }
      next.cardSectionShowConfig.title = '统计数据板块';
      if (!next.cardConfig) {
        next.cardConfig = {
          title: '板块内容设置',
          tabTitle: '板块内容设置',
          list: getDefaultHomeCardList()
        };
      }
      next.cardConfig.list = normalizeHomeCardList(next.cardConfig.list);
      return next;
    },
    getConfig: function getConfig() {
      if (this.configObj.searConfig.tabVal === 0) {
        this.configObj.logoConfig.isShow = 0;
        this.configObj.logoFixConfig.isShow = 0;
      } else {
        this.configObj.logoConfig.isShow = 1;
        this.configObj.logoFixConfig.isShow = 1;
      }
    }
  }
};